export enum ECrud {
  CREATE = 'create',
  UPDATE = 'update',
  REMOVE = 'remove',
  INFO = 'info',
}
